import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fetchStaffMemberByIdQueryOptions } from "@/api/staff";
import { useApiParameters } from "@/hooks/useApiParameters";
import { StaffForm } from "@/routes/_auth/app/_app/org/$orgId/staff/-components/StaffForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/staff/$staffId/edit",
)({
	loader: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const { orgId, staffId } = params;

		// Preload staff member data
		await context.queryClient.ensureQueryData(
			fetchStaffMemberByIdQueryOptions(userId, token, orgId, staffId),
		);

		return { userId, token, orgId, staffId };
	},
	component: EditStaffPage,
});

function EditStaffPage() {
	const { orgId, staffId } = Route.useParams();
	const { userId, token } = Route.useLoaderData();

	// Fetch staff member data
	const { data: staffMember } = useSuspenseQuery(
		fetchStaffMemberByIdQueryOptions(userId, token, orgId, staffId),
	);

	return (
		<div className="h-full flex flex-col space-y-6">
			<div className="h-full overflow-auto" data-testid="staff-form-container">
				<StaffForm staffMember={staffMember} />
			</div>
		</div>
	);
}
